import { inject } from '@angular/core';
import { ResolveFn, RedirectCommand } from '@angular/router';
import { CompaniesService } from '../services/companies.service';

// TODO: Reemplazar any con la interfaz correcta de la configuración del login
type LoginConfig = any;

export const LoginConfigResolver: ResolveFn<LoginConfig | null | RedirectCommand> = (route, state) => {
    const companiesService = inject(CompaniesService);
    const queryParams = route.queryParamMap;
    const companyCode = queryParams.get('c');

    if (companyCode) {
        localStorage.setItem('lastUserLoginBrand', companyCode); // Setearlo en oauth-success y en saml2-success
        return companiesService.getCompanyLoginConfiguration(companyCode);
    }

    return null;
};
